export const MIN_STAGE_WIDTH = 32;
const WIDTH_SLACK_PX = 8;

export function stabilizeMeasuredWidth(previous: number, measured: number): number {
  if (measured < MIN_STAGE_WIDTH) return previous;
  if (previous === 0) return measured;
  if (Math.abs(previous - measured) < WIDTH_SLACK_PX) return previous;
  return measured;
}

export function shouldKeepPdfPage(
  page: number,
  rangeStart: number,
  rangeEnd: number,
  keepDistance: number,
): boolean {
  return page >= rangeStart - keepDistance && page <= rangeEnd + keepDistance;
}
